import $store from '@/store'

export default [
  {
    path: '/landing',
    component: () => import('@/pages/landing/Index.vue'),
    children: [
      {
        name: 'landing',
        path: '',
        meta: {
          requireSignin: false,
          layout: 'EmptyLayout',
        },
        redirect: 'early-payment',
      },
      {
        name: 'landing/outbound',
        path: 'outbound',
        meta: {
          requireSignin: false,
          layout: 'EmptyLayout',
        },
        component: () => import('@/pages/landing/Outbound.vue'),
      },
      {
        name: 'landing/earlyPayment',
        path: 'early-payment',
        meta: {
          requireSignin: false,
          layout: 'EmptyLayout',
        },
        component: () => import('@/pages/landing/EarlyPayment.vue'),
      },
      {
        name: 'landing/loan',
        path: 'loan',
        meta: {
          requireSignin: false,
          layout: 'EmptyLayout',
        },
        component: () => import('@/pages/landing/Loan.vue'),
      },
      {
        name: 'landing/pull-revenue',
        path: 'pull-revenue',
        meta: {
          requireSignin: true,
        },
        component: () => import('@/pages/landing/PullRevenue.vue'),
      },
      {
        name: 'landing/woori-crowd/limit-inquiry',
        path: 'woori-crowd/limit-inquiry',
        meta: {
          requireSignin: false,
          layout: 'DefaultLayoutNoStatus',
          design: { classes: ['test1234'] },
        },
        component: () => import('@/pages/landing/woori-crowd/limit-inquiry/Index.vue'),
      },
      {
        name: 'landing/woori-crowd',
        path: 'woori-crowd',
        meta: {
          requireSignin: false,
          layout: 'DefaultLayoutFluid',
          design: { classes: [''], noTopHeader: true },
        },
        component: () => import('@/pages/landing/woori-crowd/Landing.vue'),
      },
      {
        name: 'landing/nice-check',
        path: 'nice-check',
        meta: {
          requireSignin: false,
          layout: 'EmptyLayoutContainer',
          design: { classes: [''] },
        },
        beforeEnter(to, from, next) {
          // 로그인 되어있으면 선정산페이지로 리다이렉트
          if ($store.getters['auth/isAuthenticated']) {
            next({ name: 'earlypay' })
            return
          }

          next()
        },
        component: () => import('@/pages/landing/NiceCheck.vue'),
      },
    ],
  },
]
